import React, { type ImgHTMLAttributes } from 'react';

import { css } from '@betterment/samba-styled-system/css';

import { useColorMode } from '../color-mode/ColorModeProvider';

import type { SystemStyleObject } from '@betterment/samba-styled-system/types';

type ImgElement = ImgHTMLAttributes<HTMLImageElement>;

type ThemedAsset = {
  light: string;
  dark: string;
};

type ImageProps = Exclude<ImgElement, 'src' | 'alt'> & {
  alt: string;
  themedAsset: ThemedAsset;
  css?: SystemStyleObject;
};

export const ThemedImage: React.FC<ImageProps> = ({ themedAsset, alt, src: _src, css: cssProp = {}, ...imgProps }) => {
  const colorMode = useColorMode();
  return <img className={css(cssProp)} alt={alt} src={themedAsset[colorMode.colorMode]} {...imgProps} />;
};
